module.exports = __webpack_public_path__ + "5d7ec830fd8d1c440f165111719aa4a0.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/media_control/public/Player-Regular.svg
 ** module id = 45
 ** module chunks = 0
 **/